<template>
  <v-container>
    <v-dialog v-model="dialog" max-width="500px">
      <v-form v-model="valid" ref="formData">
        <v-card class="pt-3">
          <v-card-title>
            <span class="headline ml-2">{{isEdit ? $t('edit') : $t('add')}} {{$t('status')}}</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    :label="$t('name_id')"
                    v-model="dataItem.statusNameId"
                    :rules="[...rules, validator.alfaNumberNotRequired, rulesMax20]"
                    counter="20"
                    required
                    class="sae-required"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    :label="$t('name_en')"
                    v-model="dataItem.statusNameEn"
                    :rules="[...rules, validator.alfaNumberNotRequired, rulesMax20]"
                    required
                    counter="20"
                    class="sae-required"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions class="mx-6 pb-6">
            <v-row justify="center">
              <v-btn color="primary" text @click="close">{{$t('cancel')}}</v-btn>
              <v-btn
                :loading="loading"
                color="primary"
                @click="saveOrUpdate(dataItem)"
                :disabled="!valid"
              >{{$t('save')}}</v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <v-dialog v-model="deleteDialog" persistent max-width="320">
      <v-card>
        <v-card-title class="headline">{{$t('delete_data')}}</v-card-title>
        <v-card-text v-if="lang === 'id'">{{$t('delete_supervisor') + 'Status Karyawan ' + dataItem.nameId}}</v-card-text>
        <v-card-text v-else>{{$t('delete_supervisor') + dataItem.nameEn + ' Employee Status'}}</v-card-text>
        <v-card-actions class="pa-3">
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="deleteDialog = false">{{$t('cancel')}}</v-btn>
          <v-btn color="error" :loading="loading" @click="deleteComponent(dataItem)">{{$t('delete')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-row>
      <v-col>
        <v-btn right color="primary" dark class="mb-2" @click="addItem()">{{$t('add')}} {{$t('status')}}</v-btn>
      </v-col>
      <v-col md="6">
        <v-text-field
          :rules="[validator.alfaForInput]"
          :label="$t('search')"
          prepend-inner-icon="mdi-magnify"
          single-line
          v-model="search"
        ></v-text-field>
      </v-col>
    </v-row>

    <v-data-table
      :loading="loading"
      :search="search"
      :items="dataList"
      :headers="headers"
      :no-data-text="$t('no_data')"
      class="elevation-1 mt-3"
      :footer-props="{ 'items-per-page-options': [10, 50, 100], 'items-per-page-text': $t('rows_per_page') }"
    >
      <template
        v-slot:item.no="{ item }"
      >{{dataList.map(function(x) {return x.id; }).indexOf(item.id) + 1}}</template>
      <template v-slot:item.status="{ item }">
        <div v-if="item.status">
          <v-icon small class="ml-3" color="success">mdi-check-circle-outline</v-icon>
        </div>
        <div v-else>
          <v-icon small class="ml-3" color="error">mdi-alert-circle-outline</v-icon>
        </div>
      </template>
      <template v-slot:item.action="{ item }">
        <span v-if="item.schedule_code != 'x' && item.schedule_code != 'X'">
          <v-icon small class="mr-2" color="primary" @click="editedItem(item)">mdi-pencil</v-icon>
          <v-icon small color="error" @click="deleteItem(item)">mdi-delete</v-icon>
        </span>
      </template>
      <template v-slot:footer.page-text="items"> {{ items.pageStart }} - {{ items.pageStop }} {{$t('of')}} {{ items.itemsLength }} </template>
    </v-data-table>
  </v-container>
</template>

<script>
export default {
  name: "MasterEmployeeStatus",
  data() {
    return {
      isEdit: false,
      deleteScheduleTime: false,
      dialog: false,
      deleteDialog: false,
      dataList: [],
      headers: [
        { text: this.$i18n.t('no'), value: "no" },
        { text: this.$i18n.t('name_id'), value: "nameId" },
        { text: this.$i18n.t('name_en'), value: "nameEn" },
        { text: this.$i18n.t('action'), value: "action" },
      ],
      company_id: this.$store.state.company,
      validator: this.$store.state.validator,
      dataItem: {
        id: 0,
      },
      search: "",
      editedIndex: -1,
      valid: true,
      rules: [(v) => !!v || this.$i18n.t('required')],
      loading: false,
      rulesMax20: v => (v && v.length <= 20) || `${this.$i18n.t('max_char')} 20`,
    };
  },
  methods: {
    costumHeader(actionId, action) {
      return { headers: { actionId, action } }
    },
    showMessage(type, msg) {
      this.$store.dispatch('nShowMessage', { type, msg })
    },
    async getComponent() {
      this.loading = true
      const result = await this.$store.dispatch('getEmployeeWorkingStatus')
      this.loading = false
      return result
    },
    async saveOrUpdate(data) {
      if (this.isEdit) {
        this.editComponent(data)
      } else {
        this.saveComponent(data)
      }
    },
    async saveComponent(data) {
      const body = { ...data }
      this.loading = true
      const result = await this.$store.dispatch('saveEmployeeWorkingStatus', body)
      this.loading = false

      if (result) {
        this.showMessage('success', this.$i18n.t('alert_save'))
        this.dialog = false
        this.dataList = await this.getComponent()
      }
    },
    async editComponent(data) {
      const body = { ...data }
      this.loading = true
      const result = await this.$store.dispatch('editEmployeeWorkingStatus', body)
      this.loading = false
      if (result) {
        this.showMessage('success', this.$i18n.t('alert_edit'))
        this.dialog = false
        this.dataList = await this.getComponent()
      } 
    },
    async deleteComponent(data) {
      this.loading = true
      const result = await this.$store.dispatch('deleteEmployeeWorkingStatus', data)
      this.loading = false
      if (result) {
        this.showMessage('success', this.$i18n.t('alert_delete'))
        this.deleteDialog = false
        this.dataList = await this.getComponent()
      }
    },
    addItem() {
      this.isEdit = false
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },
    editedItem(item) {
      this.isEdit = true
      this.dataItem = Object.assign({}, item);
      this.dataItem.statusNameId = item.nameId
      this.dataItem.statusNameEn = item.nameEn

      this.dialog = true
    },
    deleteItem(item) {
      this.dataItem = Object.assign({}, item);
      this.deleteDialog = true;
    },
  },
  async created() {
    this.dataList = await this.getComponent()
  },
  watch: {
    dialog(show) {
      if (show && !this.isEdit) {
        if (this.$refs.formData) {
          this.$refs.formData.reset();
          this.dataItem = { id: 0 }
        }
      }
    },
  },
};
</script>
